module.exports = __webpack_public_path__ + "static/img/m_finance_ed.ddce173.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mine/m_finance_ed.png
// module id = SF+H
// module chunks = 9